// src/components/Settings/SettingsContext.js

import React, { createContext, useContext, useState } from 'react';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [isLearningMode, setIsLearningMode] = useState(() => {
        const stored = localStorage.getItem('learningMode');
        return stored === 'true';
    });

    const [forceMultiChoice, setForceMultiChoice] = useState(() => {
        const stored = localStorage.getItem('forceMultiChoice');
        return stored ? stored === 'true' : false;
    });

    const [requiredRepetitions, setRequiredRepetitions] = useState(() => {
        const stored = localStorage.getItem('requiredRepetitions');
        return stored ? Number(stored) : 1;
    });

    const toggleLearningMode = () => {
        setIsLearningMode(prev => {
            localStorage.setItem('learningMode', !prev);
            return !prev;
        });
    };

    const handleMultiChoiceToggle = (value) => {
        setForceMultiChoice(value);
        localStorage.setItem('forceMultiChoice', value);
    };

    const handleRepetitionsChange = (value) => {
        setRequiredRepetitions(value);
        localStorage.setItem('requiredRepetitions', value);
    };

    return (
        <SettingsContext.Provider value={{
            isLearningMode,
            toggleLearningMode,
            forceMultiChoice,
            setForceMultiChoice: handleMultiChoiceToggle,
            requiredRepetitions,
            setRequiredRepetitions: handleRepetitionsChange
        }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
